import { render, staticRenderFns } from "./onservice.vue?vue&type=template&id=167eaa01"
import script from "./onservice.vue?vue&type=script&lang=js"
export * from "./onservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports